import { render, staticRenderFns } from "./IFrameScan.vue?vue&type=template&id=85992ace&"
import script from "./IFrameScan.vue?vue&type=script&lang=js&"
export * from "./IFrameScan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports